import BigNumber from 'bignumber.js';
import { DlVault } from 'types/contracts';

export interface GetTimeConfigInput {
  dlVaultContract: DlVault;
}

export type GetTimeConfigOutput = {
  multiplier: BigNumber;
  testMode: boolean;
  description: string;
};

const getTimeConfig = async ({
  dlVaultContract,
}: GetTimeConfigInput): Promise<GetTimeConfigOutput> => {
  // 注释掉 getTimeConfig 调用，因为合约中不存在该方法
  // const result = await dlVaultContract.methods.getTimeConfig().call();

  // return {
  //   multiplier: new BigNumber(result.multiplier),
  //   testMode: result.testMode,
  //   description: result.description,
  // };
  
  // 返回默认值，避免类型错误
  return {
    multiplier: new BigNumber('1'),
    testMode: false,
    description: 'getTimeConfig method is not available in the contract',
  };
};

export default getTimeConfig; 